import styled from 'styled-components';

const StyledPlayerSelectorWarning = styled.div`
  text-align: left;
  color: red;
`;
interface IPlayerSelectorWarning {
  playerSelection: {
    isPlayerSelected: boolean[];
    selectedPlayer: number | null;
  };
}

const PlayerSelectorWarning = (props: IPlayerSelectorWarning) => {
  const warning =
    props.playerSelection.selectedPlayer !== null ? (
      ''
    ) : (
      <h2>Please choose a color by clicking on token!</h2>
    );

  return <StyledPlayerSelectorWarning>{warning}</StyledPlayerSelectorWarning>;
};

export default PlayerSelectorWarning;
